/* tslint:disable */
/* eslint-disable */
/**
 * Trust Investigator APP
 * The Law Society Trust Investigation Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 2.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { BooleanResponse } from '../models';
import { DoubleResponse } from '../models';
import { ExportTimeEntryRequest } from '../models';
import { SaveLeaveTimeEntryRequest } from '../models';
import { SaveTimeEntryRequest } from '../models';
import { TimeEntryApprovalRequest } from '../models';
import { TimeEntryApprovalResponse } from '../models';
import { TimeEntryIEnumerableResponse } from '../models';
import { TimeEntryRequest } from '../models';
import { TimeEntryResponse } from '../models';
/**
 * TimeEntryApi - axios parameter creator
 * @export
 */
export const TimeEntryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns boolean value
         * @param {number} timeEntryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeEntryDeleteTimeEntryTimeEntryIdDelete: async (timeEntryId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'timeEntryId' is not null or undefined
            if (timeEntryId === null || timeEntryId === undefined) {
                throw new RequiredError('timeEntryId','Required parameter timeEntryId was null or undefined when calling apiV2TimeEntryDeleteTimeEntryTimeEntryIdDelete.');
            }
            const localVarPath = `/api/v2/TimeEntry/DeleteTimeEntry/{timeEntryId}`
                .replace(`{${"timeEntryId"}}`, encodeURIComponent(String(timeEntryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns TimeEntries
         * @param {ExportTimeEntryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeEntryExportTimeEntriesPost: async (body?: ExportTimeEntryRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/TimeEntry/ExportTimeEntries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns Events
         * @param {number} maxNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeEntryGetLatestTimeEntriesMaxNumberGet: async (maxNumber: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'maxNumber' is not null or undefined
            if (maxNumber === null || maxNumber === undefined) {
                throw new RequiredError('maxNumber','Required parameter maxNumber was null or undefined when calling apiV2TimeEntryGetLatestTimeEntriesMaxNumberGet.');
            }
            const localVarPath = `/api/v2/TimeEntry/GetLatestTimeEntries/{maxNumber}`
                .replace(`{${"maxNumber"}}`, encodeURIComponent(String(maxNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns My MissingTime
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeEntryGetMyMissingTimeGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/TimeEntry/GetMyMissingTime`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns Events
         * @param {TimeEntryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeEntryGetTimeEntriesPost: async (body?: TimeEntryRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/TimeEntry/GetTimeEntries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns TimeEntryApproval
         * @param {TimeEntryApprovalRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeEntryGetTimeEntryApprovalPost: async (body?: TimeEntryApprovalRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/TimeEntry/GetTimeEntryApproval`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns TimeEntry
         * @param {number} timeEntryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeEntryGetTimeEntryByIdTimeEntryIdGet: async (timeEntryId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'timeEntryId' is not null or undefined
            if (timeEntryId === null || timeEntryId === undefined) {
                throw new RequiredError('timeEntryId','Required parameter timeEntryId was null or undefined when calling apiV2TimeEntryGetTimeEntryByIdTimeEntryIdGet.');
            }
            const localVarPath = `/api/v2/TimeEntry/GetTimeEntryById/{timeEntryId}`
                .replace(`{${"timeEntryId"}}`, encodeURIComponent(String(timeEntryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns boolean value
         * @param {SaveLeaveTimeEntryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeEntrySaveLeaveTimeEntryPost: async (body?: SaveLeaveTimeEntryRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/TimeEntry/SaveLeaveTimeEntry`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns boolean value
         * @param {SaveTimeEntryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeEntrySaveTimeEntryPost: async (body?: SaveTimeEntryRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/TimeEntry/SaveTimeEntry`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TimeEntryApi - functional programming interface
 * @export
 */
export const TimeEntryApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns boolean value
         * @param {number} timeEntryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimeEntryDeleteTimeEntryTimeEntryIdDelete(timeEntryId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await TimeEntryApiAxiosParamCreator(configuration).apiV2TimeEntryDeleteTimeEntryTimeEntryIdDelete(timeEntryId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns TimeEntries
         * @param {ExportTimeEntryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimeEntryExportTimeEntriesPost(body?: ExportTimeEntryRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeEntryIEnumerableResponse>> {
            const localVarAxiosArgs = await TimeEntryApiAxiosParamCreator(configuration).apiV2TimeEntryExportTimeEntriesPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns Events
         * @param {number} maxNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimeEntryGetLatestTimeEntriesMaxNumberGet(maxNumber: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeEntryIEnumerableResponse>> {
            const localVarAxiosArgs = await TimeEntryApiAxiosParamCreator(configuration).apiV2TimeEntryGetLatestTimeEntriesMaxNumberGet(maxNumber, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns My MissingTime
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimeEntryGetMyMissingTimeGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DoubleResponse>> {
            const localVarAxiosArgs = await TimeEntryApiAxiosParamCreator(configuration).apiV2TimeEntryGetMyMissingTimeGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns Events
         * @param {TimeEntryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimeEntryGetTimeEntriesPost(body?: TimeEntryRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeEntryIEnumerableResponse>> {
            const localVarAxiosArgs = await TimeEntryApiAxiosParamCreator(configuration).apiV2TimeEntryGetTimeEntriesPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns TimeEntryApproval
         * @param {TimeEntryApprovalRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimeEntryGetTimeEntryApprovalPost(body?: TimeEntryApprovalRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeEntryApprovalResponse>> {
            const localVarAxiosArgs = await TimeEntryApiAxiosParamCreator(configuration).apiV2TimeEntryGetTimeEntryApprovalPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns TimeEntry
         * @param {number} timeEntryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimeEntryGetTimeEntryByIdTimeEntryIdGet(timeEntryId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TimeEntryResponse>> {
            const localVarAxiosArgs = await TimeEntryApiAxiosParamCreator(configuration).apiV2TimeEntryGetTimeEntryByIdTimeEntryIdGet(timeEntryId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns boolean value
         * @param {SaveLeaveTimeEntryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimeEntrySaveLeaveTimeEntryPost(body?: SaveLeaveTimeEntryRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await TimeEntryApiAxiosParamCreator(configuration).apiV2TimeEntrySaveLeaveTimeEntryPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns boolean value
         * @param {SaveTimeEntryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TimeEntrySaveTimeEntryPost(body?: SaveTimeEntryRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await TimeEntryApiAxiosParamCreator(configuration).apiV2TimeEntrySaveTimeEntryPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * TimeEntryApi - factory interface
 * @export
 */
export const TimeEntryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Returns boolean value
         * @param {number} timeEntryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeEntryDeleteTimeEntryTimeEntryIdDelete(timeEntryId: number, options?: any): AxiosPromise<BooleanResponse> {
            return TimeEntryApiFp(configuration).apiV2TimeEntryDeleteTimeEntryTimeEntryIdDelete(timeEntryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns TimeEntries
         * @param {ExportTimeEntryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeEntryExportTimeEntriesPost(body?: ExportTimeEntryRequest, options?: any): AxiosPromise<TimeEntryIEnumerableResponse> {
            return TimeEntryApiFp(configuration).apiV2TimeEntryExportTimeEntriesPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns Events
         * @param {number} maxNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeEntryGetLatestTimeEntriesMaxNumberGet(maxNumber: number, options?: any): AxiosPromise<TimeEntryIEnumerableResponse> {
            return TimeEntryApiFp(configuration).apiV2TimeEntryGetLatestTimeEntriesMaxNumberGet(maxNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns My MissingTime
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeEntryGetMyMissingTimeGet(options?: any): AxiosPromise<DoubleResponse> {
            return TimeEntryApiFp(configuration).apiV2TimeEntryGetMyMissingTimeGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns Events
         * @param {TimeEntryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeEntryGetTimeEntriesPost(body?: TimeEntryRequest, options?: any): AxiosPromise<TimeEntryIEnumerableResponse> {
            return TimeEntryApiFp(configuration).apiV2TimeEntryGetTimeEntriesPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns TimeEntryApproval
         * @param {TimeEntryApprovalRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeEntryGetTimeEntryApprovalPost(body?: TimeEntryApprovalRequest, options?: any): AxiosPromise<TimeEntryApprovalResponse> {
            return TimeEntryApiFp(configuration).apiV2TimeEntryGetTimeEntryApprovalPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns TimeEntry
         * @param {number} timeEntryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeEntryGetTimeEntryByIdTimeEntryIdGet(timeEntryId: number, options?: any): AxiosPromise<TimeEntryResponse> {
            return TimeEntryApiFp(configuration).apiV2TimeEntryGetTimeEntryByIdTimeEntryIdGet(timeEntryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns boolean value
         * @param {SaveLeaveTimeEntryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeEntrySaveLeaveTimeEntryPost(body?: SaveLeaveTimeEntryRequest, options?: any): AxiosPromise<BooleanResponse> {
            return TimeEntryApiFp(configuration).apiV2TimeEntrySaveLeaveTimeEntryPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns boolean value
         * @param {SaveTimeEntryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TimeEntrySaveTimeEntryPost(body?: SaveTimeEntryRequest, options?: any): AxiosPromise<BooleanResponse> {
            return TimeEntryApiFp(configuration).apiV2TimeEntrySaveTimeEntryPost(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TimeEntryApi - object-oriented interface
 * @export
 * @class TimeEntryApi
 * @extends {BaseAPI}
 */
export class TimeEntryApi extends BaseAPI {
    /**
     * 
     * @summary Returns boolean value
     * @param {number} timeEntryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeEntryApi
     */
    public apiV2TimeEntryDeleteTimeEntryTimeEntryIdDelete(timeEntryId: number, options?: any) {
        return TimeEntryApiFp(this.configuration).apiV2TimeEntryDeleteTimeEntryTimeEntryIdDelete(timeEntryId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns TimeEntries
     * @param {ExportTimeEntryRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeEntryApi
     */
    public apiV2TimeEntryExportTimeEntriesPost(body?: ExportTimeEntryRequest, options?: any) {
        return TimeEntryApiFp(this.configuration).apiV2TimeEntryExportTimeEntriesPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns Events
     * @param {number} maxNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeEntryApi
     */
    public apiV2TimeEntryGetLatestTimeEntriesMaxNumberGet(maxNumber: number, options?: any) {
        return TimeEntryApiFp(this.configuration).apiV2TimeEntryGetLatestTimeEntriesMaxNumberGet(maxNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns My MissingTime
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeEntryApi
     */
    public apiV2TimeEntryGetMyMissingTimeGet(options?: any) {
        return TimeEntryApiFp(this.configuration).apiV2TimeEntryGetMyMissingTimeGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns Events
     * @param {TimeEntryRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeEntryApi
     */
    public apiV2TimeEntryGetTimeEntriesPost(body?: TimeEntryRequest, options?: any) {
        return TimeEntryApiFp(this.configuration).apiV2TimeEntryGetTimeEntriesPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns TimeEntryApproval
     * @param {TimeEntryApprovalRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeEntryApi
     */
    public apiV2TimeEntryGetTimeEntryApprovalPost(body?: TimeEntryApprovalRequest, options?: any) {
        return TimeEntryApiFp(this.configuration).apiV2TimeEntryGetTimeEntryApprovalPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns TimeEntry
     * @param {number} timeEntryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeEntryApi
     */
    public apiV2TimeEntryGetTimeEntryByIdTimeEntryIdGet(timeEntryId: number, options?: any) {
        return TimeEntryApiFp(this.configuration).apiV2TimeEntryGetTimeEntryByIdTimeEntryIdGet(timeEntryId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns boolean value
     * @param {SaveLeaveTimeEntryRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeEntryApi
     */
    public apiV2TimeEntrySaveLeaveTimeEntryPost(body?: SaveLeaveTimeEntryRequest, options?: any) {
        return TimeEntryApiFp(this.configuration).apiV2TimeEntrySaveLeaveTimeEntryPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns boolean value
     * @param {SaveTimeEntryRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TimeEntryApi
     */
    public apiV2TimeEntrySaveTimeEntryPost(body?: SaveTimeEntryRequest, options?: any) {
        return TimeEntryApiFp(this.configuration).apiV2TimeEntrySaveTimeEntryPost(body, options).then((request) => request(this.axios, this.basePath));
    }
}
